/* eslint-disable react/prop-types */
import { Navigate, Outlet } from 'react-router-dom'
import { withRouter } from '../../withRouter'
import { TabBar } from '../../components/generic'

function TodosScreen({ location, router, testId }) {
  return (
    <div data-testid={testId || 'todos-screen'}>
      <TabBar 
        items={NAV_TABS} 
        resourceUrl="todos" 
        location={location} 
        data-testid={testId ? `${testId}-tab-bar` : 'todos-screen-tab-bar'}
      />
      {router.location.pathname === '/todos' ? (
        <Navigate to="dashboard" />
      ) : (
        <Outlet />
      )}
    </div>
  )
}

export default withRouter(TodosScreen)

const NAV_TABS = [
  {
    url: 'dashboard',
    label: 'Daily Dashboard',
  },
  {
    url: 'manage',
    label: "Manage To-Do's",
  },
]
